import { useEffect, useState } from "react";
import type { MomentMessageType, MomentMoreButton } from "../../data/momentOptions";
import { SectionBox, inputCls } from "../shared";

type Props = {
  messageType: MomentMessageType;
  moreButtonEnabled: boolean;
  moreButton: MomentMoreButton;
  onMoreButtonEnabledChange: (value: boolean) => void;
  onMoreButtonChange: (key: "pcLandingUrl" | "mobileLandingUrl", value: string) => void;
};

export default function MoreButtonSection({
  messageType,
  moreButtonEnabled,
  moreButton,
  onMoreButtonEnabledChange,
  onMoreButtonChange,
}: Props) {
  const [moreButtonPcEnabled, setMoreButtonPcEnabled] = useState(moreButton.pcLandingUrl.trim().length > 0);

  useEffect(() => {
    setMoreButtonPcEnabled(moreButton.pcLandingUrl.trim().length > 0);
  }, [moreButton.pcLandingUrl]);

  return (
    <SectionBox label="더보기 버튼" enabled={moreButtonEnabled} onToggle={onMoreButtonEnabledChange}>
      <div>
        <label className="tw-block tw-text-xs tw-text-gray-500 tw-mb-1.5">
          <span className="tw-text-red-500 tw-mr-1">*</span>
          모바일 랜딩 URL
        </label>
        <input
          value={moreButton.mobileLandingUrl}
          onChange={(e) => onMoreButtonChange("mobileLandingUrl", e.target.value)}
          placeholder="https://"
          className={inputCls}
        />
      </div>
      <label className="tw-flex tw-items-center tw-gap-1.5 tw-text-xs tw-text-gray-600 tw-cursor-pointer tw-w-fit">
        <input
          type="checkbox"
          checked={moreButtonPcEnabled}
          onChange={(e) => {
            const checked = e.target.checked;
            setMoreButtonPcEnabled(checked);
            if (!checked) onMoreButtonChange("pcLandingUrl", "");
          }}
          className="tw-w-3.5 tw-h-3.5"
        />
        PC 링크
      </label>
      {moreButtonPcEnabled && (
        <div>
          <label className="tw-block tw-text-xs tw-text-gray-500 tw-mb-1.5">PC 랜딩 URL</label>
          <input
            value={moreButton.pcLandingUrl}
            onChange={(e) => onMoreButtonChange("pcLandingUrl", e.target.value)}
            placeholder="https://"
            className={inputCls}
          />
        </div>
      )}
      {messageType === "CAROUSEL_COMMERCE_MESSAGE" && (
        <p className="tw-text-xs tw-text-gray-400">
          캐러셀 커머스의 인트로 카드는 첫 번째 카드 정보와 이미지를 기준으로 생성합니다.
        </p>
      )}
    </SectionBox>
  );
}
